import { NFT } from "@/types/nft/nft";
import useFetch from "../useFetch/useFetch";
import { getNFT } from "@/services/nft/nft";
import { ParamsNFTConfigType, ParamsNFTProps } from "./use-get-nft-type";
import { useEffect, useRef } from "react";

const useGetNFT  = (
  collectionKey: string, 
  main_key: string | null,
  configParams?: ParamsNFTConfigType
) => {
  const paramsNFT = useRef<ParamsNFTProps>({
    collection_key: collectionKey,
    owner: main_key ?? undefined,
    cache: true,
    limit: 1,
    page: 0,
    order: 'created_desc',
    ...configParams
  });

  const { data: nft, loading, error, startFetch } = useFetch<NFT[], object>(getNFT, paramsNFT.current);
  const isOwner = nft?.length > 0 && String(main_key) === String(nft[0]?.owner);

  const firstRender = useRef<boolean>(true);
  useEffect(() => {
    if (!loading && nft?.length === 0 && firstRender.current) {
      firstRender.current = false;
      delete paramsNFT.current.owner;
      startFetch();
    }
  }, [loading, nft, startFetch]);

	return {
    nft,
    loading,
    error,
    isOwner,
    startFetch
	};
};

export { useGetNFT } ;